<template>
	<div class="reset-page">
		<!-- 装饰背景 -->
		<div class="bg-decor">
			<div class="blob blob-a"></div>
			<div class="blob blob-b"></div>
			<svg class="grid-svg" width="100%" height="100%" preserveAspectRatio="none">
				<defs>
					<pattern id="resetGrid" width="48" height="48" patternUnits="userSpaceOnUse">
						<path d="M 48 0 L 0 0 0 48" fill="none" stroke="rgba(46,173,158,0.06)" stroke-width="1" />
					</pattern>
				</defs>
				<rect width="100%" height="100%" fill="url(#resetGrid)" />
			</svg>
		</div>

		<div class="form-card">
			<div class="form-head">
				<button class="back-btn" type="button" @click="login">
					<el-icon>
						<ArrowLeft />
					</el-icon>
					<span>返回登录</span>
				</button>
				<div class="welcome">找回密码</div>
				<div class="welcome-sub" v-if="!registerFlag">
					请按照以下步骤重置您的登录密码
				</div>
				<div class="welcome-sub" v-else>
					密码已重置 · 请使用新密码登录
				</div>
			</div>

			<!-- 步骤指示器 -->
			<div class="steps" v-if="!registerFlag">
				<div class="step" :class="{ active: !showNext, done: showNext }">
					<div class="step-no">1</div>
					<div class="step-label">验证账号</div>
				</div>
				<div class="step-line" :class="{ done: showNext }"></div>
				<div class="step" :class="{ active: showNext }">
					<div class="step-no">2</div>
					<div class="step-label">重置密码</div>
				</div>
				<div class="step-line"></div>
				<div class="step">
					<div class="step-no">3</div>
					<div class="step-label">重置完成</div>
				</div>
			</div>

			<!-- 表单 -->
			<el-form v-if="!registerFlag" :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top"
				class="reset-form">

				<!-- 步骤 1:用户名 -->
				<template v-if="!showNext">
					<el-form-item label="登录账号" prop="userName">
						<el-input v-model="ruleForm.userName" placeholder="请输入您的登录账号" size="large"
							:prefix-icon="Icons.User" :disabled="userNameDisadled" clearable />
					</el-form-item>
					<div class="form-tip">
						系统将根据账号匹配注册手机号,用于发送验证码
					</div>
					<div class="actions">
						<el-button class="btn-secondary" size="large" @click="login">取消</el-button>
						<el-button class="btn-primary" size="large" :loading="loadingPhone"
							@click="next('ruleForm')">
							下一步
						</el-button>
					</div>
				</template>

				<!-- 步骤 2:验证码 + 新密码 -->
				<template v-else>
					<el-form-item label="注册手机号" prop="phone">
						<el-input v-model="ruleForm.phone" disabled size="large" :prefix-icon="Icons.Iphone" />
					</el-form-item>
					<div class="form-tip phone-tip">
						验证码将发送至上述手机号,请注意查收
					</div>

					<el-form-item label="短信验证码" prop="code">
						<div class="code-row">
							<el-input v-model="ruleForm.code" placeholder="请输入 6 位短信验证码" maxlength="6" size="large"
								:prefix-icon="Icons.Message" />
							<el-button class="btn-code" size="large"
								:disabled="!registerCodeInfo.getCodeisWaiting" @click="getCode">
								{{ registerCodeInfo.getCodeText }}
							</el-button>
						</div>
					</el-form-item>

					<el-form-item label="新登录密码" prop="loginPassword">
						<el-input type="password" v-model="ruleForm.loginPassword" placeholder="请输入 6-20 位新密码"
							size="large" :prefix-icon="Icons.Lock" show-password />
					</el-form-item>

					<el-form-item label="确认新密码" prop="confirmPassword">
						<el-input type="password" v-model="ruleForm.confirmPassword" placeholder="请再次输入新密码"
							size="large" :prefix-icon="Icons.Lock" show-password />
					</el-form-item>

					<div class="actions">
						<el-button class="btn-secondary" size="large" @click="login">取消</el-button>
						<el-button class="btn-primary" size="large" :loading="loadingSubmit"
							@click="submitForm('ruleForm')">
							确认重置
						</el-button>
					</div>
				</template>
			</el-form>

			<!-- 步骤 3:成功 -->
			<div class="success-block" v-else>
				<div class="success-icon">
					<svg viewBox="0 0 80 80" width="72" height="72">
						<circle cx="40" cy="40" r="36" fill="rgba(46,173,158,0.12)" />
						<circle cx="40" cy="40" r="26" fill="#2EAD9E" />
						<path d="M28 41 L37 50 L54 32" stroke="#FFFFFF" stroke-width="4" fill="none"
							stroke-linecap="round" stroke-linejoin="round" />
					</svg>
				</div>
				<div class="success-title">密码重置成功</div>
				<div class="success-desc">
					请妥善保管您的账号信息<br />
					点击下方按钮使用新密码登录系统
				</div>
				<el-button class="btn-primary btn-block" size="large" @click="login">
					立即登录
				</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	import { markRaw } from "vue";
	import {
		User,
		Lock,
		Iphone,
		Message,
		ArrowLeft,
	} from "@element-plus/icons-vue";
	import NProgress from "nprogress";

	export default {
		components: {
			ArrowLeft,
		},
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === "") {
					callback(new Error("请再次输入密码"));
				} else if (value !== this.ruleForm.loginPassword) {
					callback(new Error("两次输入密码不一致!"));
				} else {
					callback();
				}
			};

			return {
				registerFlag: false,
				loadingPhone: false,
				loadingSubmit: false,
				Icons: {
					User: markRaw(User),
					Lock: markRaw(Lock),
					Iphone: markRaw(Iphone),
					Message: markRaw(Message),
				},
				ruleForm: {
					userName: "",
					loginPassword: "",
					confirmPassword: "",
					phone: "",
					code: "",
				},
				rules: {
					code: [{
						required: true,
						message: "请输入短信验证码",
						trigger: "blur",
					}],
					userName: [
						{
							required: true,
							message: "请输入登录账号",
							trigger: "blur",
						},
						{
							min: 2,
							max: 20,
							message: "长度在 2 到 20 个字符",
							trigger: "change",
						},
					],
					loginPassword: [
						{
							required: true,
							message: "请输入新登录密码",
							trigger: "blur",
						},
						{
							min: 6,
							max: 20,
							message: "长度在 6 到 20 个字符",
							trigger: "change",
						},
					],
					confirmPassword: [
						{
							required: true,
							message: "请输入确认密码",
							trigger: "blur",
						},
						{
							validator: validatePass,
							trigger: "change",
						},
					],
				},
				propertiesData: {},
				sn: "",
				registerCodeInfo: {
					holdTime: 60,
					getCodeText: "获取验证码",
					getCodeisWaiting: true,
					codeTimer: null,
				},
				showNext: false,
				userNameDisadled: false,
			};
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.loadingSubmit = true;
						this.doctorSmsVerify(this.ruleForm);
					} else {
						return false;
					}
				});
			},
			next(ruleForm) {
				this.$refs[ruleForm].validateField("userName", (valid) => {
					if (valid) {
						this.getPhone();
					}
				});
			},
			getPhone() {
				this.loadingPhone = true;
				this.$applicationJson("/business/user/getPhoneByUsername", {
						username: this.ruleForm.userName,
					})
					.then((res) => {
						this.loadingPhone = false;
						if (res.data.code == 0) {
							this.showNext = true;
							this.ruleForm.phone = res.data.data.phone;
							this.userNameDisadled = true;
						} else {
							this.$message.error(res.data.msg);
						}
					})
					.catch(() => {
						this.loadingPhone = false;
						this.$message.error("网络异常");
					});
			},
			getCode() {
				if (!this.registerCodeInfo.getCodeisWaiting) {
					return false;
				}
				if (!this.ruleForm.phone) {
					this.$message.error("未获取到注册手机号");
					return;
				}
				this.getSms(this.ruleForm.phone);
			},
			getSms(phone) {
				this.$applicationJson("/business/user/sms", {
						phone: phone,
						type: 0,
					})
					.then((res) => {
						if (res.data.code == 200) {
							this.$message.success("验证码已发送");
							this.setTimer(this.registerCodeInfo);
							this.registerCodeInfo.getCodeisWaiting = false;
							NProgress.done();
						} else {
							this.$message.error(res.data.msg);
							NProgress.done();
						}
					})
					.catch(() => {
						this.$message.error("网络异常");
					});
			},
			doctorSmsVerify(info) {
				this.$applicationJson("/business/user/sms/verify", {
						phone: info.phone,
						captcha: info.code,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.register();
						} else {
							this.loadingSubmit = false;
							this.$message.error(res.data.msg);
						}
					})
					.catch((Error) => {
						this.loadingSubmit = false;
						console.log(Error);
					});
			},
			setTimer(registerCodeInfo) {
				registerCodeInfo.holdTime = 60;
				registerCodeInfo.getCodeText = "重新获取(60s)";
				registerCodeInfo.codeTimer = setInterval(() => {
					if (registerCodeInfo.holdTime <= 0) {
						registerCodeInfo.getCodeisWaiting = true;
						registerCodeInfo.getCodeText = "获取验证码";
						clearInterval(registerCodeInfo.codeTimer);
						return;
					}
					registerCodeInfo.getCodeText =
						"重新获取(" + registerCodeInfo.holdTime + "s)";
					registerCodeInfo.holdTime--;
				}, 1000);
			},
			validatePhone(rule, value, callback) {
				if (value === "") {
					callback(new Error("请输入手机号码"));
				} else if (!/^1[3|4|5|7|8][0-9]{9}$/.test(value)) {
					callback(new Error("请输入正确的手机号码"));
				} else {
					callback();
				}
			},
			login() {
				this.$router.push("/login/login");
			},
			register() {
				this.$applicationJson("/business/user/reset", {
						captcha: this.ruleForm.code,
						username: this.ruleForm.userName,
						password: this.ruleForm.loginPassword,
						phone: this.ruleForm.phone,
					})
					.then((res) => {
						this.loadingSubmit = false;
						if (res.data.code == 0) {
							this.registerFlag = true;
							this.$message.success("修改成功");
						} else {
							this.$message.error(res.data.msg);
						}
					})
					.catch(() => {
						this.loadingSubmit = false;
						this.$message.error("网络异常");
					});
			},
		},
		created() {
			this.$nextTick(() => {
				this.propertiesData = window.parseProps();
				if (this.propertiesData.sn) {
					this.sn = this.propertiesData.sn;
				}
			});
		},
	};
</script>

<style lang="less" scoped>
	@primary-500: #2EAD9E;
	@primary-600: #258F83;
	@primary-700: #1D7268;
	@gray-50: #FAFAF8;
	@gray-100: #F2F1ED;
	@gray-200: #E6E4DE;
	@gray-300: #D2CFC6;
	@gray-500: #8C8A82;
	@gray-700: #4A4946;
	@gray-900: #1F1E1B;
	@font-serif: "Noto Serif SC", "Source Han Serif SC", "PingFang SC", serif;
	@font-sans: "Noto Sans SC", "PingFang SC", "Microsoft YaHei", sans-serif;

	.reset-page {
		position: fixed;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: @font-sans;
		background: linear-gradient(180deg, @gray-50 0%, #F4F2EC 100%);
		overflow: auto;
		color: @gray-900;
		padding: 24px;
	}

	.bg-decor {
		position: absolute;
		inset: 0;
		pointer-events: none;
		overflow: hidden;
		z-index: 0;

		.grid-svg {
			position: absolute;
			inset: 0;
		}

		.blob {
			position: absolute;
			border-radius: 50%;
			filter: blur(60px);
			opacity: 0.5;
		}

		.blob-a {
			width: 480px;
			height: 480px;
			background: radial-gradient(circle, rgba(46, 173, 158, 0.32), transparent 70%);
			top: -160px;
			left: -180px;
		}

		.blob-b {
			width: 420px;
			height: 420px;
			background: radial-gradient(circle, rgba(255, 198, 96, 0.24), transparent 70%);
			bottom: -160px;
			right: -140px;
		}
	}

	.form-card {
		position: relative;
		z-index: 1;
		width: 100%;
		max-width: 480px;
		background: #fff;
		border-radius: 20px;
		padding: 40px 44px 36px;
		box-shadow: 0 20px 50px rgba(21, 84, 77, 0.12),
			0 4px 12px rgba(21, 84, 77, 0.05);
	}

	.form-head {
		margin-bottom: 28px;

		.back-btn {
			display: inline-flex;
			align-items: center;
			gap: 4px;
			background: transparent;
			border: none;
			padding: 4px 0;
			color: @gray-500;
			font-size: 13px;
			cursor: pointer;
			margin-bottom: 16px;
			transition: color 0.18s ease;

			.el-icon {
				font-size: 14px;
			}

			&:hover {
				color: @primary-600;
			}
		}

		.welcome {
			font-family: @font-serif;
			font-size: 26px;
			font-weight: 600;
			color: @gray-900;
			line-height: 1.2;
			letter-spacing: 1px;
		}

		.welcome-sub {
			margin-top: 8px;
			font-size: 13px;
			color: @gray-500;
			letter-spacing: 0.4px;
		}
	}

	.steps {
		display: flex;
		align-items: center;
		margin-bottom: 28px;

		.step {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 6px;

			.step-no {
				width: 32px;
				height: 32px;
				border-radius: 50%;
				background: @gray-100;
				color: @gray-500;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 14px;
				font-weight: 600;
				transition: all 0.25s ease;
			}

			.step-label {
				font-size: 12px;
				color: @gray-500;
				transition: color 0.25s ease;
			}

			&.active {
				.step-no {
					background: @primary-500;
					color: #fff;
					box-shadow: 0 0 0 4px rgba(46, 173, 158, 0.18);
				}

				.step-label {
					color: @primary-700;
					font-weight: 500;
				}
			}

			&.done {
				.step-no {
					background: rgba(46, 173, 158, 0.12);
					color: @primary-600;
				}

				.step-label {
					color: @primary-600;
				}
			}
		}

		.step-line {
			flex: 1;
			height: 2px;
			background: @gray-100;
			margin: 0 12px 18px;
			transition: background 0.25s ease;

			&.done {
				background: rgba(46, 173, 158, 0.5);
			}
		}
	}

	.reset-form {
		:deep(.el-form-item) {
			margin-bottom: 18px;
		}

		:deep(.el-form-item__label) {
			font-size: 13px;
			color: @gray-700;
			padding-bottom: 6px;
			line-height: 1.4;
		}

		:deep(.el-input__wrapper) {
			border-radius: 10px;
			padding: 4px 12px;
			background: @gray-50;
			box-shadow: 0 0 0 1px @gray-200 inset;
			transition: all 0.18s ease;

			&:hover {
				box-shadow: 0 0 0 1px @primary-500 inset;
			}

			&.is-focus {
				background: #fff;
				box-shadow: 0 0 0 1px @primary-500 inset,
					0 0 0 3px rgba(46, 173, 158, 0.12) !important;
			}
		}

		:deep(.el-input__inner) {
			height: 42px;
			font-size: 14px;
			color: @gray-900;
		}

		:deep(.el-input__prefix) {
			color: @gray-500;
			font-size: 16px;
		}
	}

	.form-tip {
		font-size: 12px;
		color: @gray-500;
		line-height: 1.7;
		margin: -6px 0 16px;
		padding: 8px 12px;
		background: rgba(46, 173, 158, 0.06);
		border-left: 3px solid @primary-500;
		border-radius: 0 6px 6px 0;
	}

	.phone-tip {
		margin-top: -8px;
		margin-bottom: 16px;
	}

	.code-row {
		display: flex;
		gap: 10px;
		width: 100%;

		:deep(.el-input) {
			flex: 1;
		}

		.btn-code {
			flex-shrink: 0;
			min-width: 120px;
			height: 42px;
			border-radius: 10px;
			background: #fff;
			border: 1px solid @primary-500;
			color: @primary-600;
			font-size: 13px;
			padding: 0 14px;
			transition: all 0.18s ease;

			&:hover:not(.is-disabled) {
				background: rgba(46, 173, 158, 0.08);
				color: @primary-700;
			}

			&.is-disabled {
				border-color: @gray-200;
				color: @gray-500;
				background: @gray-50;
				cursor: not-allowed;
			}
		}
	}

	.actions {
		display: flex;
		gap: 12px;
		margin-top: 24px;

		.el-button {
			flex: 1;
			height: 44px;
			border-radius: 10px;
			font-size: 15px;
			letter-spacing: 2px;
		}
	}

	.btn-primary {
		background: linear-gradient(135deg, @primary-500, @primary-600);
		border: none;
		color: #fff;
		box-shadow: 0 6px 18px rgba(46, 173, 158, 0.32);
		transition: transform 0.16s ease, box-shadow 0.16s ease;

		&:hover {
			background: linear-gradient(135deg, @primary-600, @primary-700);
			color: #fff;
			transform: translateY(-1px);
			box-shadow: 0 10px 22px rgba(46, 173, 158, 0.4);
		}

		&:active {
			transform: translateY(0);
		}

		&:focus {
			color: #fff;
			background: linear-gradient(135deg, @primary-500, @primary-600);
		}
	}

	.btn-secondary {
		background: #fff;
		border: 1px solid @gray-200;
		color: @gray-700;

		&:hover {
			background: @gray-50;
			border-color: @gray-300;
			color: @gray-900;
		}
	}

	.btn-block {
		width: 100%;
		margin-top: 12px;
	}

	.success-block {
		text-align: center;
		padding: 16px 0 4px;

		.success-icon {
			display: flex;
			justify-content: center;
			margin-bottom: 20px;

			svg {
				filter: drop-shadow(0 8px 20px rgba(46, 173, 158, 0.28));
			}
		}

		.success-title {
			font-family: @font-serif;
			font-size: 22px;
			font-weight: 600;
			color: @gray-900;
			letter-spacing: 1px;
			margin-bottom: 10px;
		}

		.success-desc {
			font-size: 13px;
			line-height: 1.9;
			color: @gray-500;
			margin-bottom: 24px;
		}
	}

	@media (max-width: 600px) {
		.form-card {
			padding: 32px 24px 28px;
		}
	}
</style>
